import i18n from "@/modules/i18n"
import store from "@/store/"
import SuccessPageController from "@/pages/success-page/components/success-page-controller"

export default function createSuccessPageApp(Vue) {
  return new Vue({
    name: "SuccessPage",
    i18n: i18n,
    store,
    render: (h) => h(SuccessPageController)
  })
}
